import { useAccountControllerGetAccount } from '@api'
import { UserDto as HellojoyUserDto } from '~/api/public/models'
import { UserDto } from '@api/models'
import { useOutletContext } from 'react-router-dom'

type OutletContextType = { user: HellojoyUserDto }

export function usePublicUser() {
  return useOutletContext<OutletContextType>()
}

export function useAuthUser(): { user: UserDto } {
  const queryData = useAccountControllerGetAccount()

  return {
    user: queryData.data as UserDto
  }
}
